import React from 'react';
import {LandingPagePropTypes} from '@ignitesales/neuro-application';
import {DialogueClientLogo, LandingPageStartButton, WelcomeMessage, WelcomeTitle} from "../../index.js";

const LandingPage = ({ componentClass }) => {
    return (
        <div className={componentClass}>
            <div className="container">
                <div className={`${componentClass}__center`}>
                    <div className="left-side">
                        <DialogueClientLogo className="logo" />
                        <WelcomeTitle tagName="h1" />
                    </div>
                    <div className="right-side">
                        <WelcomeMessage tagName="p" />
                        <LandingPageStartButton />
                    </div>
                </div>
            </div>
        </div>
    );
};

LandingPage.propTypes = LandingPagePropTypes;

export default LandingPage;
